import React, { Fragment } from 'react'
import MediaWithContent from '../MediaWithContent'
import Content from '../../content'

import './image-with-content.scss'
import { StateProvider } from '../../core';

const ImageWithContentSection = ({ data = {}, context = {} }) => {
  const {
    image,
    imageMobile,
    content,
    imageLeftDesktop,
    ...rest
  } = data

  if (
    !image
    || !content
    || !content[0]
  ) {
    return null
  }

  const forceHideMediaMobile = (
    content[0].__typename === 'ContentfulContentWidget'
      && content[0].type === 'memberships-list'
  )

  const anchor = content[0].__typename === 'ContentfulContentWidget'
    ? content[0].type
    : undefined

  const mobileImage = imageMobile || image

  return (
    <StateProvider>{( customImage, setCustomImage ) => (
      <MediaWithContent
        media={(
          <Fragment>
            {customImage && customImage.resize && <div 
              styleName='image custom-image' 
              style={{
                backgroundImage: `url(${customImage.resize.src})`,
              }}
            />}
            <div 
              styleName='image desktop '
              style={{
                backgroundImage: `url(${(image).resize.src})`,
              }}
            />
            <div 
              styleName='image mobile '
              style={{
                backgroundImage: `url(${(mobileImage).resize.src})`,
              }}
            />
          </Fragment>
        )}
        content={(
          <div styleName='content'>
            {content[0].static 
              || <Content 
                typename={content[0].__typename} 
                id={content[0].id} 
                context={context}
                setCustomImage={setCustomImage}
              />}
          </div>
        )}
        mediaLeftDesktop={imageLeftDesktop}
        {...rest}
        anchor={anchor}
        hideImageOnMobile={forceHideMediaMobile || data.hideImageOnMobile}

      />
    )}</StateProvider>
  )
}

export default ImageWithContentSection